const AppCallPlugin = {};

// 3. 컴포넌트 옵션 주입
import { SocialMixin } from '../mixins/SocialMixin';

AppCallPlugin.install = function (Vue) {

    Vue.mixin(SocialMixin);

    Vue.prototype.$_callbackAppCurrentLocation = function(lat, har) {
        this.$store.commit('SET_CURRENT_LOCATION',{ lat, har })
    }

    Vue.prototype.$_appPopupMessage = function(msg) {
        this.$store.commit('OPEN_MODAL', {
            title:'안내',
            content: msg,
            btnOne: '확인',
        });
    }

    Vue.prototype.$_kakaoSocialCallback = function(auth) {
        if(['Login'].includes(this.$route.name)) {
            this.kakaoLogin(auth);
        } 
        
        else if(['JoinSocial','MyInfo'].includes(this.$route.name)){
            this.kakaoConnect(auth);
        }
        
    }

    Vue.prototype.$_googleSocialCallback = function(auth) {
        if(['Login'].includes(this.$route.name)) {
            this.googleLogin(auth);
        } 
        
        else if(['JoinSocial','MyInfo'].includes(this.$route.name)){
            this.googleConnect(auth);
        }
    }

    Vue.prototype.$_appleSocialCallback = function(auth) {
        if(['Login'].includes(this.$route.name)) {
            this.appleLogin(auth);
        } 
        
        else if(['JoinSocial','MyInfo'].includes(this.$route.name)){
            this.appleConnect(auth);
        }
    }
}

export default AppCallPlugin;